// extracted by mini-css-extract-plugin
export default {"carousel":"LocationSection_carousel__ODcN2","location":"LocationSection_location__rmr52"};